import React from 'react';
import { Chart } from 'primereact/chart';

interface WeeklyRevenueData {
    current: string;
    change: string;
    comparison: string;
    chartData: Array<{ day: string; revenue: number }>;
    dailyBreakdown: Array<{ day: string; amount: string }>;
}

interface WeeklyRevenueProps {
    data: WeeklyRevenueData;
}

const WeeklyRevenue: React.FC<WeeklyRevenueProps> = ({ data }) => {
    const chartData = {
        labels: data.chartData.map((item) => item.day),
        datasets: [
            {
                label: 'Total Revenue',
                data: data.chartData.map((item) => item.revenue),
                borderColor: '#4A90E2',
                backgroundColor: 'rgba(74, 144, 226, 0.1)',
                borderWidth: 2,
                fill: true,
                tension: 0.4,
                pointBackgroundColor: '#4A90E2',
                pointBorderColor: '#ffffff',
                pointBorderWidth: 2,
                pointRadius: 4,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0,0,0,0.1)',
                },
                ticks: {
                    callback: function (value: any) {
                        return '$' + (value / 1000).toFixed(1) + 'K';
                    },
                },
            },
            x: {
                grid: {
                    display: false,
                },
            },
        },
    };

    const isNegativeChange = data.change.startsWith('-');

    return (
        <div className="weekly-revenue-card dashboard-card dashboard-card-wrapper coming-soon-card h-100">
            <div className="card-header mb-3">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <h5 className="card-title mb-0">
                        <i className="ri-line-chart-line me-2"></i>
                        Weekly Revenue
                    </h5>
                </div>

                <div className="revenue-summary">
                    <div className="current-revenue mb-1">
                        <span className="revenue-amount">{data.current}</span>
                    </div>
                    <div className="revenue-change">
                        <span className={`change-indicator ${isNegativeChange ? 'negative' : 'positive'}`}>
                            <i className={`ri-arrow-${isNegativeChange ? 'down' : 'up'}-line me-1`}></i>
                            {data.change}
                        </span>
                        <span className="text-muted ms-2">{data.comparison}</span>
                    </div>
                </div>
            </div>

            <div className="chart-container mb-3" style={{ height: '200px' }}>
                <Chart type="line" data={chartData} options={options} />
            </div>

            <div className="daily-breakdown">
                <div className="breakdown-grid">
                    {data.dailyBreakdown.map((day, index) => (
                        <div key={index} className="breakdown-item">
                            <div className="day-label text-muted">{day.day}</div>
                            <div className="day-amount fw-bold">{day.amount}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WeeklyRevenue;
